export default __webpack_public_path__ + "static/inline-prompt-dark-713bf89bc07a575081fa8a1c84fe36b8d9c8e9dd5fd8aa4273f24c033881da94.png";